import { useFetch } from './use-fetch';
import { contactRequestConfig } from 'request-config/contact/contact.request-config';
import { fileProviderRequestConfig } from 'request-config/file-provider/file-provider.request-config';
import { useQueryClient } from '@tanstack/react-query';

const useAvatarById = () => {
  const queryClient = useQueryClient();
  const { fetch } = useFetch({ isShowLoading: false, isShowSuccessSnackbar: false, isShowErrorSnackbar: false });

  const getAvatarById = async (id: string) => {
    if (!id) return null;

    return queryClient.fetchQuery({
      queryKey: ['avatar-by-id', id],
      queryFn: async () => {
        const avatarResponse = await fetch({
          requestConfig: contactRequestConfig.getAvatar(id)
        });

        if (avatarResponse?.data?.data?.length) {
          const { data } = await fetch({
            requestConfig: fileProviderRequestConfig.downloadFile(
              avatarResponse.data.data[0].storageFileId,
              'contact',
              2
            )
          });

          const blob = new Blob([data], { type: 'application/octet-stream' });
          return URL.createObjectURL(blob);
        }

        return null;
      },
      gcTime: 0
    });
  };

  return { getAvatarById };
};

export default useAvatarById;
